import { ILeaveContactsFormValue } from '../types';
import { ILeaveContactsRequest } from '../../../repositories/e2e-deal-form/v2/leave-contacts';
import { FORM_PHONE_PREFIX } from '../constants';
import { ESentFrom } from '../../../repositories/e2e-deal-form/entities/availability/LeaveContactsV2RequestSchema';

export interface IGetLeaveContactsRequestParamsDeps {
  formValue: ILeaveContactsFormValue;
  sentFrom: ESentFrom;
}

export const getLeaveContactsRequestParams = ({
  formValue,
  sentFrom,
}: IGetLeaveContactsRequestParamsDeps): ILeaveContactsRequest => {
  return {
    name: formValue.name,
    phone: `${FORM_PHONE_PREFIX}${formValue.phone}`,
    sentFrom,
  };
};
